import React, { useEffect } from 'react'
import { Button, Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { Redirect } from "react-router-dom";
import { setSolicitudDiscapacidadAutoG } from '../../../../actions/webAfiliado/afiliadoDiscapacidadActions';
import { useDispatch } from 'react-redux';
import { STEPPER_INTEGRACION_AUTO_G } from '../../../Discapacidad/data/constants';

const useStyles = makeStyles((theme) => ({
    buttons: {
        marginTop: "2rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-around"
    },
    container: {
        backgroundColor: "#fff", marginTop: "1rem"
    }
}));

export const NuevaSolicStep1 = (props) => {
    const { idAfiliado, credenciales, datosContacto, solicitudSeleccionada } = props
    const dispatch = useDispatch();
    const classes = useStyles()

    const [redirect, setRedirect] = React.useState(false);

    useEffect(() => {
        if (idAfiliado !== "") {
            props.handleGetDataContacto()
        }
    }, [idAfiliado])

    const handleSubmit = () => {
        if(!solicitudSeleccionada?.idSolicitud)  dispatch(setSolicitudDiscapacidadAutoG({idAfiliado: idAfiliado}));
        props.handleChangeStep(STEPPER_INTEGRACION_AUTO_G.DETALLES_ORDEN)
    }

    return (
        <Grid container className={classes.container}>
            <Grid item xs={null} sm={null} md={3} />
            <Grid item xs={12} md={6}>
                <ValidatorForm onSubmit={handleSubmit}>
                    {/* <SelectValidator
                        // variant="outlined"
                        margin="normal"
                        fullWidth
                        label="Seleccioná una/un beneficiaria/o"
                        onChange={props.handleInputChange}
                        name="idAfiliado"
                        type="password"
                        validators={['required']}
                        errorMessages={['Debe seleccionar una/un beneficiaria/o']}
                        value={idAfiliado}
                    >
                        {
                            credenciales.map(e => {
                                return <MenuItem key={e.idAfiliado} value={e.idAfiliado}>{e.apellidoYNombre}</MenuItem>
                            })
                        }
                    </SelectValidator> */}
                    {
                        datosContacto !== null &&
                        <Card variant="outlined" style={{ marginTop: "1rem" }}>
                            <CardContent>
                                <Typography variant="body2">Tus datos de contacto son:</Typography>
                                <Typography variant="body2"><Typography variant="caption">Teléfono: {datosContacto.telefono}</Typography> {datosContacto.telefono === "" && <Typography variant="caption" color="error">No registrado</Typography>}</Typography>
                                <Typography variant="body2"><Typography variant="caption">Celular: {datosContacto.celular}</Typography> {datosContacto.celular === "" && <Typography variant="caption" color="error">No registrado</Typography>}</Typography>
                                <Typography variant="body2"><Typography variant="caption">Correo electrónico: {datosContacto.mail}</Typography> {datosContacto.mail === "" && <Typography variant="caption" color="error">No registrado</Typography>}</Typography>
                                <div style={{ marginTop: "1rem" }}>
                                    {
                                        // eslint-disable-next-line
                                        credenciales.find((e) => e.idAfiliado == idAfiliado)?.vigente === true
                                            ?
                                            <>
                                                {
                                                    (datosContacto && datosContacto.mail !== "" && (datosContacto.celular.length === 10 && !isNaN(datosContacto.celular)))
                                                        ?
                                                        <Typography variant="caption" color="primary" align="justify">Antes de continuar, si los datos de contacto no son correctos, actualizalos haciendo clic <u style={{cursor: 'pointer'}} onClick={() => setRedirect(true)}>aquí</u>.</Typography>
                                                        :
                                                        <Typography variant="caption" color="error" align="justify">Sus datos de contacto no son válidos para continuar. Por favor, actualicelos antes de continuar haciendo clic <u style={{cursor: 'pointer'}} onClick={() => setRedirect(true)}>aquí</u></Typography>
                                                }
                                            </>
                                            :
                                            <Typography variant="caption" color="error" align="justify">La persona seleccionada ha sido dada de baja o su cobertura no se encuentra vigente.</Typography>
                                    }
                                </div>
                            </CardContent>
                        </Card>
                    }
                    <div className={classes.buttons}>
                        <Button
                            type="button"
                            variant="contained"
                            color="secondary"
                            disabled
                            style={{textTransform:"none"}}
                        >
                            Anterior
                        </Button>
                        {
                            // eslint-disable-next-line
                            (idAfiliado === "" || (credenciales?.find((e) => e.idAfiliado == idAfiliado)?.vigente === true && (datosContacto && datosContacto.mail !== "" && (datosContacto.celular.length == 10 && !isNaN(datosContacto.celular))))) &&
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{textTransform:"none"}}
                            >
                                Siguiente
                            </Button>
                        }
                    </div>
                    {redirect &&
                      <Redirect
                        to={{
                          pathname: `/afiliado/datos-contacto/${idAfiliado}`,
                          state: { from: '/afiliado/discapacidad' }
                        }}
                      />
                    }
                </ValidatorForm>
            </Grid>
            <Grid item xs={null} sm={null} md={3} />
        </Grid>
    )
}
